/*
  eslint
  react/no-array-index-key: off
*/
import React, { PropTypes } from 'react';
import moment from 'moment/min/moment.min';

import './styles.scss';

export const PendingList = props => (
  <div className="pending-list">
    <div className="heading">
      <h2>{props.title} ({props.amount})</h2>
      <h4>Time</h4>
    </div>
    {
      props.list.map((item, index) => (
        <div className="staff" key={index}>
          <p><i className={`fa fa-circle ${item.status}`} />{item.name}
          </p>
          <p>
            {moment.unix(item.time).format('ddd Do MMM  ')}
            {moment.unix(item.time).format(' h:mm a')}
          </p>
        </div>
      ))
    }
  </div>
);

PendingList.propTypes = {
  title: PropTypes.string,
  amount: PropTypes.number,
  list: PropTypes.array,
};

export default PendingList;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/pending/PendingList/main.jsx